import { LocalizationProvider } from '@mui/x-date-pickers'
import { AdapterMoment }        from '@mui/x-date-pickers/AdapterMoment'
import App from './App'

// Entry point da view — o route.js importa este default export.
// Não usa Redux: o Dashboard é read-only e todo o estado (dados + filtros)
// vive localmente no App via hooks, o que mantém a view autocontida e leve.
export default function ActivityTrackerDashboard() {
  return (
    <LocalizationProvider dateAdapter={AdapterMoment}>
      <App />
    </LocalizationProvider>
  )
}
